const translations = {
  Ratings: {
    de_DE: 'Bewertungen',
    nl_NL: 'Waarderingen'
  },
  'Customer review from %s': {
    de_DE: 'Kundenmeinung vom %s',
    nl_NL: 'Klantbeoordeling van %s'
  },
  'Next step': {
    de_DE: 'weiter',
    nl_NL: 'Volgende'
  },
  'Previous step': {
    de_DE: 'zurück',
    nl_NL: 'Terug'
  },
  'Teststring %s for %s': {
    de_DE: 'Testwort %s für %s',
    nl_NL: 'Testwoord %s vor %s'
  },
  'Write a review': {
    de_DE: 'Bewertung schreiben',
    nl_NL: 'Schrijf een recensie'
  },
  average: {
    de_DE: 'Gesamt',
    nl_NL: 'Gemiddelde'
  },
  Verified: {
    de_DE: 'Verifiziert',
    nl_NL: 'Geverifieerd'
  },
  'No reviews yet': {
    de_DE: 'Noch keine Bewertungen',
    nl_NL: 'Nog geen beoordelingen'
  },
  'Be the first to rate this product!': {
    de_DE: 'Hinterlasse die erste Produktbewertung!',
    nl_NL: 'Beoordeel dit product als eerste!'
  },
  'My Wishlist': {
    de_DE: 'Mein Wunschzettel',
    nl_NL: 'Mijn wenslijst'
  },
  'You have no products on your wishlist yet': {
    de_DE: 'Du hast noch keine Produkte auf deinem Wunschzettel',
    nl_NL: 'U heeft nog geen producten op uw verlanglijst'
  },
  'Get in touch: ': {
    de_DE: 'Unsere Kontaktmöglichkeiten: ',
    nl_NL: 'Onze contactmogelijkheden: '
  },
  'Frequent questions': {
    de_DE: 'Oft gestellte Fragen '
  },
  'Verified reviews are written from registered users': {
    de_DE:
      '“Verifizierte“ Bewertungen stammen von unseren registrierten Kunden. Rezensionen ohne den Zusatz “Verifiziert“ sind ebenfalls wertvoll. Wir überprüfen bei diesen Bewertungen jedoch nicht, ob und wo die Rezensenten das Produkt gekauft haben, oder ob sie das Produkt vor dem Abgeben der Rezension verwendet haben.',
    nl_NL:
      '“Geverifieerde“ beoordelingen komen van onze geregistreerde klanten. Recensies zonder de toevoeging "Geverifieerd" zijn ook waardevol. Voor deze beoordelingen controleren we echter niet of en waar de beoordelaar het product heeft gekocht, of of hij het product heeft gebruikt voordat hij de beoordeling indiende.'
  }
};

// eslint-disable-next-line no-underscore-dangle
const __ = ({ val, locale, substitution = [], dictionary }) => {
  const translate = (dict) => (dict && dict[val] ? dict[val][locale] || dict[val].de_DE : undefined);

  let translation = translate(dictionary) || translate(translations);

  if (!translation) {
    return val;
  }

  substitution.forEach((sub) => {
    translation = translation.replace(/%s/, sub);
  });
  return translation;
};

module.exports = __;
